import * as localforage from "localforage";

export const spstorage = localforage.createInstance({
  driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE, localforage.WEBSQL]
});
